import {createFileRoute} from '@tanstack/react-router';

import {Library} from '@/features/Library/components/Library';

export const Route = createFileRoute('/_b/_p/_library')({
  component: Library,
});
